export default __webpack_public_path__ + "static/media/showroom-2022.c0699242.jpg";